import z from 'zod';
import { t } from 'i18next';
import { differenceInYears } from 'date-fns';
import { getIsDateValid, getParsedDateAsISO } from '@lili/utils/formatting';
import { OnboardingFormFields } from '@Types/index.ts';

export const birthDateSchema = z.object({
  [OnboardingFormFields.DATE_OF_BIRTH]: z
    .string()
    .min(1, t('enErrors:required'))
    .refine(
      (rawDate) => {
        const cleanedDate = rawDate.replace(/[^0-9]/g, '');
        return cleanedDate.length === 8;
      },
      { message: t('enErrors:dateOfBirth') }
    )
    .superRefine((rawDateOfBirth, ctx) => {
      if (typeof rawDateOfBirth === 'string' && rawDateOfBirth.length > 0) {
        if (!getIsDateValid(rawDateOfBirth)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('enErrors:dateOfBirthInvalid'),
          });
        } else {
          const parsedDate = getParsedDateAsISO(rawDateOfBirth);
          const age = differenceInYears(new Date(), new Date(parsedDate));

          if (age < 18) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t('enErrors:olderThen18'),
            });
          }

          if (age > 120) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t('enErrors:dateOfBirthInvalid'),
            });
          }
        }
      }
    }),
});
